import API from '../modules/api';
import { Controller } from 'stimulus';
import Mustache from 'mustache';
import UrlHandler from '../modules/urlhandler';
import Map from '../modules/map';
import Baidu from '../modules/baidu';

const api = new API({ authStoreKey: 'news-filters' });
const URL = new UrlHandler();
const MAP = new Map();
const BAIDU = new Baidu();

const PARAMS = {
  //limit: 6, // Limit removed. Map needs all references at once and cards needs to be filtered by landingPageDisabled property.
  offset: 0,
  locations: URL.getParameter('locations'),
  woodTypes: URL.getParameter('woodTypes'),
  keyword: URL.getParameter('keyword', 'string'),
}

let pagination = {};
let layoutLimit = 6;
let pages = 0;
let page = 0;

export default class extends Controller {
  static targets = [
    'map',
    'baiduMap',
    'list',
    'template',
    'woodTypes',
    'locations',
    'keyword',
    'buttonContainer',
    'button',
    'paginationTemplate',
    'paginationContainer',
  ];

  /**
   * Automatically called when stimulus has initialized controller
   */
  initialize() {
    URL.addHandler(this.locationsTargets, true);
    URL.addHandler(this.woodTypesTargets, true);
    URL.addHandler(this.keywordTarget);

    this.getData()
      .then(data => {
        if (typeof data.result !== 'undefined' && typeof data.result.references !== 'undefined' && data.result.references.length > 0) {
          this.render(this.listTarget, this.templateTarget, this._formatData(data));
        }
      });
    this.updateButtons();
  }

  /**
   * Format data for mustache template
   * @param {array} data Array of XHR response to format
   * @return {array}
   */
  _formatData(data) {
    if (data.result.pagination) {
      pagination = data.result.pagination;
    }

    return Array.isArray(data.result.references) ?
      { items: data.result.references.filter(item => {
        item.category = item.locationName;
        item.content = item.ingress.length > 120 ? item.ingress.slice(0, 120) + '...' : item.ingress;
        item.image = item.heroImage ? item.heroImage.thumbnail : null;
        item.webpImage = item.heroImage ? item.heroImage.webpThumbnail : null;
        item.title = item.name;
        item.keywords = [{ name: item.city }];
        item.contentTheme = 'dark';
        return item;
      })} : null;
  }

  /**
   * Get data from api
   * @param {object} params parameters for api getBlogArticles
   * @returns {array} blog articles
   */
  getData(params = {}) {
    params = { ...PARAMS, woodTypes: PARAMS.woodTypes, locations: PARAMS.locations};
    return api.getReferences(params);
  }

  /**
   * Update list (on select or input change)
   */
  updateList() {
    this.getData().then(data => {
      this.render(this.listTarget, this.templateTarget, this._formatData(data));
    });
  }

  /**
   * For selects, buttons etc.
   */
  inputHandler() {
    PARAMS.keyword = '';
    if (this.keywordTarget.value !== '') {
      PARAMS.keyword = this.keywordTarget.value;
      this.updateList();
    }
    if (this.woodTypesTarget.value !== '' && !PARAMS.woodTypes.includes(this.woodTypesTarget.value)) {
      PARAMS.woodTypes.push(this.woodTypesTarget.value);
      this.updateList();
      this.updateButtons();
    }
    if (this.locationsTarget.value !== '' && !PARAMS.locations.includes(this.locationsTarget.value)) {
      PARAMS.locations.push(this.locationsTarget.value);
      this.updateList();
      this.updateButtons();
    }
  }

  /**
   * Update buttons to dom
   */
  updateButtons() {
    let types = [];
    let cats = [];
    if (PARAMS.woodTypes.filter(Boolean).length > 0) {
      types = PARAMS.woodTypes.map((type) => {
        let item = { slug: type };
        item.type = 'woodTypes';
        item.name = Array.from(this.woodTypesTarget.querySelectorAll('option')).filter(option => option.value === type)[0].text;
        return item;
      });
    }
    if (PARAMS.locations.filter(Boolean).length > 0) {
      cats = PARAMS.locations.map((cat) => {
        let item = { slug: cat };
        item.type = 'locations';
        item.name = Array.from(this.locationsTarget.querySelectorAll('option')).filter(option => option.value === cat)[0].text;
        return item;
      });
    }
    this.buttonContainerTarget.innerHTML = Mustache.render(this.buttonTarget.innerHTML,
      {
        buttons: types.concat(cats).filter(Boolean)
      }
    );
  }

  /**
   * Clear all filters
   */
  clearFilters() {
    this.woodTypesTarget.value = '';
    this.locationsTarget.value = '';
    this.keywordTarget.value = '';
    PARAMS.woodTypes = [];
    PARAMS.locations = [];
    PARAMS.keyword = null;
    PARAMS.offset = 0;
    page = 0;
    this.updateList(true);
    this.updateButtons();
    URL.emptyParameters();
  }

  /**
   * Remove item from filters
   * @param {object} button element in page
   */
  removeFilter(button) {
    let type = button.currentTarget.getAttribute('data-type');
    let slug = button.currentTarget.getAttribute('data-slug');

    if (type === 'woodTypes') {
      this.woodTypesTarget.value = '';
      PARAMS.woodTypes = PARAMS.woodTypes.filter(item => item !== slug);
    } else if (type === 'locations') {
      this.locationsTarget.value = '';
      PARAMS.locations = PARAMS.locations.filter(item => item !== slug);
    }

    PARAMS.offset = 0;
    page = 0;
    this.updateList(true);
    this.updateButtons();
    URL.removeParameter(type, slug);
  }

  /**
   * Change page from buttons in pagination
   * @param {object} button element
   */
  changePage(button) {
    let buttonPage = button.currentTarget.getAttribute('data-page');
    if (buttonPage === 'next') {
      if (page < pages-1) {
        page++;
      }
    } else if (buttonPage === 'previous') {
      if (page > 0) {
        page--;
      }
    } else {
      page = +buttonPage;
    }
    this.updateLayout();
    //PARAMS.offset = page * PARAMS.limit;
    //this.updateList(true);
  }

  /**
   * Render html to page
   * @param {object} target HTML selector
   * @param {object} html Element that inner html will be rendered
   * @param {object} data Data that will be used to rendered html
   */
  render(target, html, data) {
    if (data.items) {
      if (data.items.length > 0) {
        if (document.querySelector('html').getAttribute('lang') === 'zh') {
          BAIDU.init(this.baiduMapTarget, data.items);
          this.baiduMapTarget.style.display = 'block';
        } else {
          MAP.render(this.mapTarget, data.items);
          this.mapTarget.style.display = 'block';
        }
      } else {
        this.mapTarget.style.display = 'none';
      }
      target.innerHTML = '';
      data.items.forEach((item) => {
        if (!item.landingPageDisabled) {
          target.innerHTML += Mustache.render(html.innerHTML, item);
        }
      });
      this.updateLayout();
    }

    // Check if there are any references with landing page enabled. If not -> we don't need to show the pagination
    const itemsWithLandingPage = data.items.filter(item => !item.landingPageDisabled);

    if (itemsWithLandingPage.length && pagination && pagination.totalCount > layoutLimit) {

      // Override totalcount as this works little different than other paginations
      pagination.totalCount = this.listTarget.querySelectorAll('article').length;

      pages = Math.ceil(pagination.totalCount / layoutLimit);
      pagination.pages = [];
      for (let i = 0; i < pages; i++) {
        pagination.pages.push({
          active: page === i ? true : false,
          page: i,
          number: i + 1
        });
      }
      if (page === 0) {
        pagination.currentArticles = '1-' + (pagination.totalCount > layoutLimit ? layoutLimit : pagination.totalCount);
      } else if (page === pages-1) {
        pagination.currentArticles = page * layoutLimit + '-' + pagination.totalCount;
      } else {
        pagination.currentArticles = page * layoutLimit + '-' + ((page * layoutLimit) + layoutLimit)
      }
      this.paginationContainerTarget.innerHTML = Mustache.render(this.paginationTemplateTarget.innerHTML, { pagination });
    } else {
      this.paginationContainerTarget.innerHTML = Mustache.render(this.paginationTemplateTarget.innerHTML, { pagination: null });
    }
  }

  updateLayout() {
    if (page === 0) {
      pagination.currentArticles = '1-' + (pagination.totalCount > layoutLimit ? layoutLimit : pagination.totalCount);
    } else if (page === pages-1) {
      pagination.currentArticles = page * layoutLimit + '-' + pagination.totalCount;
    } else {
      pagination.currentArticles = page * layoutLimit + '-' + ((page * layoutLimit) + layoutLimit)
    }
    this.paginationContainerTarget.innerHTML = Mustache.render(this.paginationTemplateTarget.innerHTML, { pagination });
    this.paginationContainerTarget.querySelectorAll('button').forEach((button) => { button.classList.remove('active'); })

    this.paginationContainerTarget.querySelector('button[data-page="' + page || 0 + '"]')?.classList.add('active');

    this.listTarget.querySelectorAll('article').forEach((item, i) => {
      item.style.display = 'none';
      let count = (page+1) * layoutLimit;
      if (i+1 <= count && i+1 > count - layoutLimit) {
        item.style.display = 'block';
      }
    });
  }
}
